import React, { useState, useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  getAllBranches,
  createBranch,
  updateBranch,
  deleteBranch,
} from "../../api/Api";

const BranchesCrud = () => {
  const [branches, setBranches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({
    name: "",
    address: "",
    contactNumber: "",
    email: "",
    isMainbranch: false,
    isActive: true,
  });
  const [editingId, setEditingId] = useState(null);

  useEffect(() => {
    fetchBranches();
  }, []);

  const fetchBranches = async () => {
    try {
      setLoading(true);
      const response = await getAllBranches();
      if (response && Array.isArray(response.data)) {
        setBranches(response.data);
      } else {
        setBranches([]);
      }
    } catch (err) {
      console.error("Error fetching branches:", err);
      toast.error("Failed to load branches.");
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name.trim()) {
      toast.error("Branch name is required.");
      return;
    }
    try {
      if (editingId) {
        await updateBranch(editingId, formData);
        toast.success("Branch updated successfully!");
      } else {
        await createBranch(formData);
        toast.success("Branch created successfully!");
      }
      setFormData({ name: "", address: "", contactNumber: "", email: "" });
      setEditingId(null);
      fetchBranches();
    } catch (err) {
      console.error("Error saving branch:", err);
      toast.error("Failed to save branch.");
    }
  };

  const handleEditClick = (branch) => {
    setEditingId(branch._id);
    setFormData({
      name: branch.name,
      address: branch.address || "",
      contactNumber: branch.contactNumber || "",
      email: branch.email || "",
      isMainbranch: branch.isMainbranch || false,
      isActive: branch.isActive || false,
    });
  };

  const handleDeleteClick = async (id) => {
    if (window.confirm("Are you sure you want to delete this branch?")) {
      try {
        await deleteBranch(id);
        toast.success("Branch deleted successfully!");
        fetchBranches();
      } catch (err) {
        console.error("Error deleting branch:", err);
        toast.error("Failed to delete branch.");
      }
    }
  };

  const handleCancel = () => {
    setEditingId(null);
    setFormData({ name: "", address: "", contactNumber: "", email: "" });
  };

  if (loading) {
    return <div className="p-6 text-center">Loading branches...</div>;
  }

  return (
    <div className="p-6 max-w-screen-xl mx-auto bg-white rounded-xl shadow-md min-h-screen">
      <ToastContainer position="top-right" autoClose={3000} />

      <h2 className="text-2xl font-bold mb-6 text-[#16bab1]">
        Manage Branches
      </h2>

      {/* Branch Form */}
      <div className="mb-8 p-6 border border-gray-100 rounded-xl bg-gray-50 shadow-sm">
        <h3 className="text-lg font-semibold mb-4 text-gray-700">
          {editingId ? "Edit Branch" : "Add New Branch"}
        </h3>
        <form
          onSubmit={handleSubmit}
          className="grid grid-cols-1 md:grid-cols-2 gap-4"
        >
          <div>
            <label className="block text-sm font-medium text-gray-600 mb-1">
              Branch Name*
            </label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              placeholder="e.g. Downtown Branch"
              className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-[#16bab1] bg-white"
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-600 mb-1">
              Email
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              placeholder="branch@kalamkids.com"
              className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-[#16bab1] bg-white"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-600 mb-1">
              Contact Number
            </label>
            <input
              type="text"
              name="contactNumber"
              value={formData.contactNumber}
              onChange={handleInputChange}
              placeholder="+1234567890"
              className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-[#16bab1] bg-white"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-600 mb-1">
              Address
            </label>
            <input
              type="text"
              name="address"
              value={formData.address}
              onChange={handleInputChange}
              placeholder="123 Main St, City"
              className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-[#16bab1] bg-white"
            />
          </div>
          <div className="flex items-center gap-2 mt-2">
  <input
    type="checkbox"
    name="isMainbranch"
    checked={formData.isMainbranch || false}
    onChange={(e) =>
      setFormData({ ...formData, isMainbranch: e.target.checked })
    }
    className="h-4 w-4"
  />
  <label className="text-sm font-medium text-gray-600">
    Main Branch
  </label>
</div>

<div className="flex items-center gap-2 mt-2">
  <input
    type="checkbox" className="accent-[#16bab1] h-4 w-4" 
    name="isActive"
    checked={formData.isActive || false}
    onChange={(e) =>
      setFormData({ ...formData, isActive: e.target.checked })
    }
    
  />
  <label className="text-sm font-medium text-gray-600">
    Active
  </label>
</div>
          <div className="md:col-span-2 flex justify-end gap-3 mt-2">
            {editingId && (
              <button
                type="button"
                onClick={handleCancel}
                className="bg-gray-200 text-gray-700 px-6 py-3 rounded-lg hover:bg-gray-300 transition font-medium"
              >
                Cancel
              </button>
            )}
            <button
              type="submit"
              className="bg-[#16bab1] text-white px-8 py-3 rounded-lg hover:bg-[#139a93] transition font-medium shadow-sm"
            >
              {editingId ? "Update Branch" : "Add Branch"}
            </button>
          </div>
        </form>
      </div>

      {/* Branches List */}
      <div className="mt-8">
        <h3 className="text-xl font-bold mb-4 text-gray-800">
          Existing Branches
        </h3>
        {branches.length === 0 ? (
          <p className="text-gray-500 text-center py-8 bg-gray-50 rounded-lg border border-gray-100">
            No branches found. Start by adding one above.
          </p>
        ) : (
          <div className="overflow-x-auto rounded-lg border border-gray-200 shadow-sm">
            <table className="min-w-full bg-white">
              <thead className="bg-[#16bab1] text-white">
                <tr>
                  <th className="py-3 px-4 text-left font-semibold text-sm">
                    Branch Name
                  </th>
                  <th className="py-3 px-4 text-left font-semibold text-sm">
                    Contact
                  </th>
                  <th className="py-3 px-4 text-left font-semibold text-sm">
                    Email
                  </th>
                  <th className="py-3 px-4 text-center font-semibold text-sm">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {branches.map((branch) => (
                  <tr key={branch._id} className="hover:bg-gray-50 transition">
                    <td className="py-3 px-4 text-sm font-medium text-gray-800">
                      {branch.name}
                    </td>
                    <td className="py-3 px-4 text-sm text-gray-600">
                      {branch.contactNumber || "-"}
                    </td>
                    <td className="py-3 px-4 text-sm text-gray-600">
                      {branch.email || "-"}
                    </td>
                    <td className="py-3 px-4">
                      <div className="flex justify-center gap-4">
                        <button
                          onClick={() => handleEditClick(branch)}
                          className="text-blue-600 hover:text-blue-800 font-medium text-sm transition"
                        >
                          Edit
                        </button>
                        <button
                          onClick={() => handleDeleteClick(branch._id)}
                          className="text-red-600 hover:text-red-800 font-medium text-sm transition"
                        >
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default BranchesCrud;
